(() => {
  'use strict';
  if (customElements.get('pb-case-features')) return;
  class CaseFeatures extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.source = this.querySelector('.pbcc-features');
      this.items = Array.from(this.source?.children || []).map(item => item.textContent.trim()).filter(Boolean);
      if (this.items.length < 2) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.visible = !('IntersectionObserver' in window);
      this.motion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
      this.stage = document.createElement('span');
      this.stage.className = 'pbcc-feature-stage';
      this.stage.setAttribute('aria-hidden', 'true');
      this.button = document.createElement('button');
      this.button.type = 'button';
      this.button.className = 'pbcc-feature-pause';
      this.append(this.stage, this.button);
      this.render();
      this.applyMotionPreference();
      this.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') { this.hovered = true; this.sync(); } }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } }, options);
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.renderButton(); this.sync(); }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.onMotion = () => this.applyMotionPreference();
      this.motion?.addEventListener?.('change', this.onMotion);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0]?.isIntersecting || false;
          this.sync();
        });
        this.observer.observe(this);
      }
      this.sync();
    }
    render() {
      this.stage.textContent = this.items[this.index];
      this.stage.title = this.items[this.index];
      this.renderButton();
    }
    renderButton() {
      this.button.textContent = this.paused ? '▶' : 'Ⅱ';
      this.button.setAttribute('aria-label', this.paused ? 'Resume rotating product features' : 'Pause rotating product features');
      this.button.title = this.paused ? 'Resume features' : 'Pause features';
    }
    applyMotionPreference() {
      const enhanced = !this.motion?.matches;
      this.classList.toggle('is-enhanced', enhanced);
      this.source.tabIndex = enhanced ? -1 : 0;
      this.sync();
    }
    canRun() {
      return this.isConnected && !this.paused && !this.hovered && !this.focused && this.visible && !document.hidden && !this.motion?.matches;
    }
    sync() {
      this.stop();
      if (this.canRun()) this.timer = setTimeout(() => this.advance(), 4200);
    }
    advance() {
      if (!this.canRun()) return;
      this.stage.classList.add('is-leaving');
      this.transitionTimer = setTimeout(() => {
        if (!this.canRun()) { this.stop(); return; }
        this.index = (this.index + 1) % this.items.length;
        this.render();
        this.stage.classList.remove('is-leaving');
        this.animation = this.stage.animate?.([{opacity:0,transform:'translateY(4px)'},{opacity:1,transform:'translateY(0)'}], {duration:450,easing:'ease-out'});
        this.timer = setTimeout(() => this.advance(), 4200);
      }, 220);
    }
    stop() {
      clearTimeout(this.timer);
      clearTimeout(this.transitionTimer);
      this.animation?.cancel();
      this.stage?.classList.remove('is-leaving');
    }
    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      this.motion?.removeEventListener?.('change', this.onMotion);
      this.controller?.abort();
      this.controller = null;
      this.stage?.remove();
      this.button?.remove();
      this.classList.remove('is-enhanced');
      if (this.source) this.source.tabIndex = 0;
    }
  }
  customElements.define('pb-case-features', CaseFeatures);
})();
